var _circle, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAvatarBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#17A2B8",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M44 44C49.5228 44 54 39.5228 54 34C54 28.4772 49.5228 24 44 24C38.4772 24 34 28.4772 34 34C34 39.5228 38.4772 44 44 44Z",
    fill: "#17A2B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 58C48 59.42 48.3 60.78 48.82 62H32C28.68 62 26 59.32 26 56C26 52.68 28.68 50 32 50H52C49.58 51.82 48 54.74 48 58Z",
    fill: "#17A2B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M58 48C52.48 48 48 52.48 48 58C48 63.52 52.48 68 58 68C63.52 68 68 63.52 68 58C68 52.48 63.52 48 58 48Z",
    fill: "#17A2B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63 60H53C51.896 60 51 59.104 51 58C51 56.896 51.896 56 53 56H63C64.104 56 65 56.896 65 58C65 59.104 64.104 60 63 60Z",
    fill: "#17A2B8"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarBlue);
export default __webpack_public_path__ + "static/media/avatar-blue.a71b8d4a6c7f4d10a57bd9e4f6b2fd58.svg";
export { ForwardRef as ReactComponent };